<template>
  <div class="wrapper ">
    <!-- <notifications></notifications> -->
    <side-bar class="side-bar" v-if="showNavbar">
      <template v-slot:links>
        <sidebar-item :link="{
          name: 'Dashboard',
          icon: 'ni ni-shop text-primary',
        }">
          <sidebar-item :link="{ name: 'Technical' }">
            <sidebar-item :link="{ name: 'Overview', path: '/techDashboard' }"></sidebar-item>
            <sidebar-item :link="{ name: 'Database', path: '/databaseDashboard' }"></sidebar-item>
            <sidebar-item :link="{ name: 'Scheduled Jobs', path: '/scheduledDashboard' }"></sidebar-item>
            <sidebar-item :link="{ name: 'System', path: '/systemDashboard' }"></sidebar-item>
          </sidebar-item>
          <sidebar-item :link="{ name: 'Sales', path: '/salesDashboard' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Status', path: '/statusDashboard' }"></sidebar-item>
          <sidebar-item
            :link="{ name: 'Analytics', path: '/analyticsDashboard', relatedPaths: ['/positionDetails'] }"></sidebar-item>
          <sidebar-item
            :link="{ name: 'Strategy', path: '/strategyDashboard', relatedPaths: ['/StrategyDetails/:month'] }"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{
          name: 'System',
          icon: 'ni ni-atom text-red',
        }">
          <sidebar-item :link="{
            name: 'Users',
            path: '/system/users',
            relatedPaths: ['/system/onboarding','/system/uploadUsers']
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: 'Brokers',
            path: '/system/brokers',
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: 'Holidays',
            path: '/system/holidays',
          }">
          </sidebar-item>

          <sidebar-item :link="{
            name: 'Instruments',
            path: '/system/instruments',
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: 'Portfolios',
            path: '/system/portfolios',
            relatedPaths: ['/system/variation']
          }">
          </sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{
          name: 'Reports',
          icon: 'ni ni-chart-pie-35 text-info',
        }">
          <sidebar-item :link="{ name: 'Orders', path: '/report/orders' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Failed Orders', path: '/system/OrderRetry' }"></sidebar-item>
        </sidebar-item>

        <sidebar-item v-if="isAdmin"
          :link="{ name: 'Settings', icon: 'ni ni-settings-gear-65', path: '/buttonsPage/setting' }"></sidebar-item>
        <sidebar-item :link="{ name: 'Feeder', icon: 'fas fa-link', path: '/system/feeder' }"></sidebar-item>
        <sidebar-item :link="{ name: 'CandleStick Chart', icon: 'fas  fa-chart-bar', path: '/system/candlestick' }"></sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType" v-if="showNavbar"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <router-view></router-view>
      </div>
      <content-footer v-if="showNavbar"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
  },
  data() {
    return {
      isPlaying: false,
      isIconOnly: true,
      nn: this.$sidebar.showSidebar,
      isAdmin: false,

    }
  },
  computed: {
    toggleText() {
      return this.isPlaying ? 'Pause' : 'Play';
    },
    iconClasses() {
      return this.isPlaying
        ? 'fas fa-pause '
        : 'fas fa-play ';
    },
    backgroundClass() {
      return this.isPlaying
        ? 'bg-purple'
        : 'bg-green';
    },
    isPopout() {
      const q = this.$route?.query || {};
      return Object.prototype.hasOwnProperty.call(q, "popout");
    },
    showSidebar() {
      return !this.$route.meta.hideSidebar && !this.isPopout;
    },
    showNavbar() {
      return !this.isPopout;
    },
    showFooter() {
      return !this.$route.meta.hideFooter && !this.isPopout;
    },
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    onMainClick() {
      if (!this.isPopout) this.$sidebar.displaySidebar(false);
    },
    togglePlayPause() {
      this.isPlaying = !this.isPlaying;
    },
  },
  mounted() {
    this.isAdmin = sessionStorage.getItem("isAdmin");
    this.initScrollbar();
  },
};
</script>
<style lang="scss"></style>
